import React, { useState } from "react";

export default function CopyableCell({ text, children }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    // Try the execCommand method first (works in more environments)
    try {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      // Make the textarea invisible
      textArea.style.position = "fixed";
      textArea.style.top = "-9999px";
      textArea.style.left = "-9999px";
      textArea.style.opacity = 0;

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      const successful = document.execCommand("copy");
      document.body.removeChild(textArea);

      if (successful) {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
        return; // Exit if successful
      }
    } catch (err) {
      console.log("execCommand approach failed, trying clipboard API...");
    }

    // Only try the Clipboard API as a backup if we're in a secure context
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text)
        .then(() => {
          setCopied(true);
          setTimeout(() => setCopied(false), 2000);
        })
        .catch(err => {
          console.error("Clipboard API error:", err);
          alert("Copy failed. Please select the text and copy manually.");
        });
    } else {
      // If all else fails, let the user know
      console.error("No clipboard method available");
      alert("Copy not supported in this browser/environment. Please select the text and copy manually.");
    }
  };

  return (
    <div
      onClick={handleCopy}
      style={{ cursor: "copy", userSelect: "text" }}
      role="button"
      tabIndex={0}
      onKeyPress={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          handleCopy();
        }
      }}
      title="Click to copy"
    >
      {children}
      {copied && <span style={{ color: "green", marginLeft: "5px" }}>Copied!</span>}
    </div>
  );
}
